/* eslint-disable func-names */
// import "./lib/selectize";
// import ionRangeSlider from "ion-rangeslider";

export default function controls() {

    (function cabinsPrivelegesMore() {
        const btn = document.querySelectorAll('.cabins-privilege__show');
        if (!btn) return;
        btn.forEach((c) => {
            const parent = c.closest('.cabins-privilege__more');
            if (!parent) return;
            c.addEventListener('click', (e) => {
                e.preventDefault();
                parent.classList.toggle('cabins-privilege__more--showed');
            });
        });
    })();

    (function cabinsTotalDetails() {
        const btn = document.querySelectorAll('.total-details__control');
        if (!btn) return;
        btn.forEach((c) => {
            const parent = c.closest('.total-details');
            if (!parent) return;
            c.addEventListener('click', (e) => {
                e.preventDefault();
                parent.classList.toggle('total-details--showed');
            });
        });
    })();

    // (function inputNumber() {
    //     const inputDivs = document.querySelectorAll('.product-counter');
    //     if(!inputDivs) return;

    //     /* eslint-disable */
    //     for (let i = 0; i < inputDivs.length; i++) {

    //       const input = inputDivs[i].querySelector('input.product-counter__value');
    //       const minus = inputDivs[i].querySelector('.product-counter__minus');
    //       const plus = inputDivs[i].querySelector('.product-counter__plus');

    //       function validate(evt) {
    //         var theEvent = evt || window.event;
    //         // Handle paste
    //         if (theEvent.type === 'paste') {
    //             key = event.clipboardData.getData('text/plain');
    //         } else {
    //         // Handle key press
    //             var key = theEvent.keyCode || theEvent.which;
    //             key = String.fromCharCode(key);
    //         }
    //         var regex = /[0-9]|\./;
    //         if( !regex.test(key) ) {
    //           theEvent.returnValue = false;
    //           if(theEvent.preventDefault) theEvent.preventDefault();
    //         }
    //       }


    //       function setValue(count) {
    //         count = parseInt(count, 10)
    //         count = count < 0 ? 0 : count;
    //         count = count >= 999 ? 999 : count;
    //         input.value = count >= 0 ? count : 0;
    //     }

    //     input.addEventListener('keypress', (event) => {
    //         validate(event);
    //     });

    //     function declOfNum(number, titles) {
    //       let cases = [2, 0, 1, 1, 1, 2];
    //       return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    //     }

    //     input.addEventListener('change', () => {
    //         let val = input.value;
    //         setValue(val);
    //         if(input.classList.contains('select-filter__counter')) {
    //           let parent = input.closest('.select-filter__select');
    //           let control = parent.querySelector('.select-filter__select-control');
    //           let placeholder = control.dataset.placeholder || "Выберите";

    //           let variants = Array.from(parent.querySelectorAll('.select-filter__select-list input'))
    //           let data = variants.map((acc, item) => {
    //             return {
    //               name: acc.dataset.category || "",
    //               value: acc.value
    //             };
    //           })

    //           data = data.filter(item => item.value > 0)

    //           let result = data.map((acc) => ` ${acc.value}&nbsp;${declOfNum(acc.value, acc.name.split(','))}`)

    //           if(result.length) {
    //             control.innerHTML = result;
    //             control.classList.add('select-filter__select-control_value');
    //           } else {
    //             control.textContent = placeholder;
    //             control.classList.remove('select-filter__select-control_value')
    //           }

    //         }
    //       });

    //       minus.addEventListener('click', function () {
    //         const count = parseInt(input.value, 10) - 1;
    //         setValue(count);
    //         input.dispatchEvent(new Event('change'));
    //         return false;
    //       });

    //       plus.addEventListener('click', function () {
    //         const count = parseInt(input.value, 10) + 1;
    //         setValue(count);
    //         input.dispatchEvent(new Event('change'));
    //         return false;
    //       });
    //     }
    //     /* eslint-enable */

    //   })();

    (function selectToggle() {
        const selectes = document.querySelectorAll('.select-filter__select-control, .select-filter__apply');

        for (let i = 0; i < selectes.length; i++) {
            const item = selectes[i];
            const parent = item.closest('.select-filter__select');
            item.addEventListener('click', () => {
                parent.classList.toggle('select-filter__select_open');
            });
        }
    })();

    (function selectRadioSet() {
        const radios = document.querySelectorAll('.select-filter__radio');

        for (let i = 0; i < radios.length; i++) {
            const item = radios[i];
            const parent = item.closest('.select-filter__select');
            const control = parent.querySelector('.select-filter__select-control');
            const placeholder = control.dataset.placeholder || "Выберите";
            item.addEventListener('click', () => {
                parent.classList.toggle('select-filter__select_open');
                control.textContent = item.dataset.value || item.value;
                control.classList.add('select-filter__select-control_value');
            });
        }
    })();

    document.addEventListener('click', function (event) {
        const items = document.querySelectorAll('.select-filter__select');
        let result = false;
        for (let i = 0; i < items.length; i++) {
            let isClickInsideElement = items[i].contains(event.target);
            if (isClickInsideElement) {
                result = true;
                break;
            }
        }
        if (!result) {
            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove('select-filter__select_open');
            }
        }
    });

}
